export default "__VITE_ASSET__CylHuYXB__"